<template>
  <div id="discover">
    <top></top>
    <div class="discover bg_wrap">
      <div class="container">
        <newTitle
          class="discover_title"
          :title="'Discover Shanghai'"
        ></newTitle>
        <p class="discover_subtitle">The Top 10 Things to Do in Shanghai</p>
        <div class="discover_list">
          <div v-for="(item, index) in list" :key="index">
            <p>{{ item.name_en }}</p>
            <div v-html="item.content_en"></div>
            <div :class="item.imgs.length == 1 ? 'single' : 'multiple'">
              <img
                v-for="(item2, index2) in item.imgs"
                :key="index2"
                :src="item2"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import newTitle from "@/components/new_title.vue";
import { webAbout } from "@/api/api";
export default {
  components: {
    top,
    bottom,
    newTitle,
  },
  data() {
    return {
      type: "",
      lang: "",
      list: "",
    };
  },
  created() {
    this.lang = this.$language;
    this.type = this.$route.query.type;
    this.getRichtext();
  },
  methods: {
    async getRichtext() {
      const res = await webAbout({
        type: this.type,
      });
      if (res.code == 1) {
        this.list = res.data.lists;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.discover_subtitle {
  font-size: 22px;
  margin-top: 50px;
  margin-left: 30px;
}
.discover_list {
  > div {
    width: 100%;
    background: #edf0f6;
    border-radius: 50px;
    box-sizing: border-box;
    padding: 30px;
    margin-top: 20px;
    > p:first-child {
      font-size: 18px;
      margin-bottom: 10px;
    }
    > div:nth-child(2) {
      white-space: pre-wrap;
      overflow-wrap: break-word;
      word-break: break-all;
      /deep/ img {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain;
        display: block;
        margin: 0 auto;
      }
    }
    > div:last-child {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 30px;
      &.single {
        justify-content: center;
      }
      &.multiple {
        justify-content: space-between;
      }
      img {
        width: 580px;
        height: 440px;
        flex-shrink: 0; // 固定尺寸禁止压缩
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .discover_subtitle {
    font-size: 16px;
    margin-top: 30px;
    margin-left: 30px;
  }
  .discover_list {
    padding: 10px;
    > div {
      display: block;
      margin-top: 10px;
      > div:last-child {
        img {
          width: 100%;
          height: auto;
          aspect-ratio: 580 / 440;
          margin-bottom: 10px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .discover_subtitle {
    font-size: 16px;
    margin-top: 30px;
    margin-left: 30px;
  }
  .discover_list {
    padding: 10px;
    > div {
      display: block;
      margin-top: 10px;
      > div:last-child {
        img {
          width: 100%;
          height: auto;
          aspect-ratio: 580 / 440;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>